<template>
  <div class="main">
    <new-header title="受访者列表"></new-header>
    <div class="search-panel">
      <a-button @click="supperSearchView">高级筛选</a-button>
      <label style="margin-left: 10px">
        处理状态
      </label>
      <a-select style="width: 120px;margin-left: 10px" v-model="queryParam.handleStatus" allowClear placeholder="请选择">
        <a-select-option value="1" >未处理</a-select-option>
        <a-select-option value="2" >已处理</a-select-option>        
      </a-select>
      <label style="margin-left: 10px">
        质疑状态
      </label>
      <a-select style="width: 120px;margin-left: 10px" v-model="queryParam.status" allowClear placeholder="请选择">
        <a-select-option value="1" >未关闭</a-select-option>
        <a-select-option value="2" >已关闭</a-select-option>
      </a-select>
      <a-input class="search-item-com" v-model="queryParam.input" placeholder="请输入编号/姓名" style="width: 200px"></a-input>
      <a-button class="search-item-com" type="primary" @click="searchQueryMy">查询</a-button>
      <a-button class="search-item-com"  @click="searchReset">重置</a-button>
    </div>
    <a-table
      ref="table"
      size="small"
      :scroll="{ x: 'max-content' }"
      rowKey="id"
      :customRow="customRowFn"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange">
        <!--<span slot="action" slot-scope="text, record">-->
          <!--<a @click="handleView(record)">查看</a>-->
        <!--</span>-->
      <span slot="handleStatus" slot-scope="text, record">
          <a-tag :color="handleStatusInfo[text].color">{{ handleStatusInfo[text].text }}</a-tag>
        </span>
      <span slot="questionStatus" slot-scope="text, record">
             <a-tag :color="questionStatusInfo[text].color">{{ questionStatusInfo[text].text }}</a-tag>
        </span>
    </a-table>
    <a-drawer
      title="高级筛选"
      :width="'80%'"
      :visible="advancedVisible"
      :closable="true"
      @close="handleAdvancedCancel">
      <a-checkbox-group v-model="queryParam2.centerIdList" class="advanced-row" >
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究中心：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(center,index) in centerList" :key="index">
                <a-checkbox :value="center.center.id">
                  {{center.center.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.userIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究员：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(user,index) in userList" :key="index">
                <a-checkbox :value="user.userId">
                  {{user.realname}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.periodItemIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            周期：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(periodItem,index) in periodItemList" :key="index">
                <a-checkbox :value="periodItem.id">
                  {{periodItem.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.formIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            表单：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(form,index) in formList" :key="index">
                <a-checkbox :value="form.id">
                  {{form.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.createTypeList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            质疑来源：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="6">
                <a-checkbox value="系统">
                  系统
                </a-checkbox>
              </a-col>
              <a-col :span="6">
                <a-checkbox value="人工">
                  人工
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-row>
        <a-col :span="4" class="advanced-label">
          质疑发起日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.submitTimeList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
      <div style="text-align: right;margin-top: 20px">
        <a-button @click="handleAdvancedCancel">取消</a-button>
        <a-button @click="handleAdvancedSubmit" type="primary" style="margin-left: 20px">确定</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'
  import NewHeader from '@comp/pad/NewHeader'
  export default {
    name: 'Index',
    components: { NewHeader },
    mixins: [JeecgListMixin],
    data(){
      return{
        projectId: '',
        advancedVisible:false,
        queryParam2:{},
        handleStatusInfo:{
          "1":{color: 'orange', text: '未处理'},
          "2":{color: '', text: '已处理'}
        },
        questionStatusInfo:{
          "1":{color: '', text: '未关闭'},
          "2":{color: 'green', text: '已关闭'}
        },
        columns:[
          {
            title: '时间',
            width: 150,
            ellipsis: true,
            dataIndex: 'createTime',
          },
          {
            title: '编号',
            width: 120,
            dataIndex: 'patientNum',
          },
          {
            title: '受试者姓名',
            width: 120,
            dataIndex: 'patientName',
          },
          {
            title: '当前研究员',
            width: 100,
            dataIndex: 'userRealname',
          },
          {
            title: '周期',
            width: 100,
            dataIndex: 'periodItemName',
          },
          {
            title: '表单名称',
            width: 150,
            ellipsis: true,
            dataIndex: 'formName',
          },
          {
            title: '质疑对象',
            width: 150,
            ellipsis: true,
            dataIndex: 'formItemName',
          },
          {
            title: '质疑说明',
            width: 150,
            ellipsis: true,
            dataIndex: 'description',
          },
          {
            title: '处理状态',
            width: 100,
            ellipsis: true,
            dataIndex: 'handleStatus',
            scopedSlots: {customRender: 'handleStatus'}
          },
          {
            title: '处理详情',
            width: 150,
            ellipsis: true,
            dataIndex: 'info',
          },
          {
            title: '质疑状态',
            width: 100,
            ellipsis: true,
            dataIndex: 'status',
            scopedSlots: {customRender: 'questionStatus'}
          },
          {
            title: '质疑发起人',
            width: 100,
            ellipsis: true,
            dataIndex: 'createName',
          },

        ],
        url:{
          list:'/question/patientQuestion/list'
        },
        centerList:[],
        userList:[],
        periodItemList:[],
        formList:[],
        disableMixinCreated:true,
      }
    },
    mounted(){
      this.projectId = this.$route.query.projectId
      this.$set(this.queryParam,'handleStatus',this.$route.query.handleStatus+"")
      this.$set(this.queryParam,'status',this.$route.query.status+"")

      this.baseQueryParam = {projectId:this.projectId,isDataUser:this.$route.query.isDataUser}
      this.resetSupperParams()
      this.loadData()
      this.loadSearchData()
    },
    methods:{
      loadSearchData(){
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }
        })
        getAction('/project/projectUser/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.userList = res.result
          }
        })
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formList=res.result
          }
        })
      },

      resetSupperParams(){
        this.$set(this.queryParam2,'centerIdList',[])
        this.$set(this.queryParam2,'userIdList',[])
        this.$set(this.queryParam2,'periodItemIdList',[])
        this.$set(this.queryParam2,'formIdList',[])
        this.$set(this.queryParam2,'createTypeList',[])
        this.$set(this.queryParam2,'submitTimeList',[])
        this.$set(this.queryParam,'supper',"")
      },
      searchQueryMy(){
        // this.resetSupperParams()
        this.searchQuery()
      },
      customRowFn(record) {
        return {
          on: {
            click: () => {
              this.handleView(record)
            }
          }
        }
      },
      handleView(record){
        this.$router.push({path:'/pad/question/checkForm/'+record.formId})
      },
      handleAdvancedSubmit(){
        this.$set(this.queryParam,'handleStatus',null)
        this.$set(this.queryParam,'status',null)
        this.$set(this.queryParam,'input',null)
        this.$set(this.queryParam,'supper',JSON.stringify(this.queryParam2))
        this.loadData();
        this.handleAdvancedCancel()
      },
      handleAdvancedCancel(){
        this.advancedVisible = false
      },
      supperSearchView(){
        // this.resetSupperParams()
        this.advancedVisible = true
      }
    }
  }
</script>

<style scoped lang="less">
  .main{
    // height: calc(100vh - 60px);
    overflow-y: auto;
    background-color: white;
    .search-panel{
      text-align: left;
      padding: 0 20px;
      margin-top: 20px;
      margin-bottom: 5px;
      .search-item-com{
        margin-left: 5px;
      }
    }

    /deep/ .ant-table-pagination.ant-pagination{
      margin: 5px !important;
    }

    /deep/ .ant-table-wrapper{
      padding: 0 20px;
    }
  }
  .advanced-label{
    text-align: right;
  }
  .advanced-row{
    width: 100%;
    margin-bottom: 10px;
  }

</style>